export const mapUserToSummary = (detailedUser) => {
  if (!detailedUser) {
    return null;
  }

  return {
    id: detailedUser.id,
    firstName: detailedUser.firstName,
    middleName: detailedUser.middleName,
    lastName: detailedUser.lastName,
    email: detailedUser.email,
    userStatus: detailedUser.userStatus,
    userRole: detailedUser.userRole, // Flattened string from DTO
    createdAt: detailedUser.createdAt,
    updatedAt: detailedUser.updatedAt,
  };
};
